<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách thông báo hệ thống</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="dataPermission.includes('CNPS_TICKET_CREATE')"
          @click="create"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(startedTime)="data">
                <span class="text-center">
                  {{ data.item.startedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </span>
              </template>
              <template #cell(endedTime)="data">
                <span class="text-center">
                  {{ data.item.endedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </span>
              </template>
              <template #cell(subjects)="data">
                <span class="text-center">
                  {{ data.item.subjects ? data.item.subjects.join(', ') : '' }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click="detail(data.item.id)"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item class="dropdown-item" @click="edit(data.item.id)"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { NotificationService } from '@/services/notification.service'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'content', label: 'Nội dung', thStyle: 'min-width: 300px' },
    { key: 'startedTime', label: 'Ngày bắt đầu', thStyle: 'min-width: 150px' },
    { key: 'endedTime', label: 'Ngày kết thúc', thStyle: 'min-width: 150px' },
    { key: 'subjects', label: 'Hiển thị', thStyle: 'min-width: 150px' },
    // { key: '', label: 'Quyền' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'system-notification',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataTypeCode: [],
        search: {
          pageSize: 20,
          pageIndex: 1,
        },
        pagination: {
          total: 0,
        },
        optionTypeSale: [...Config.listTypeSale, { id: 'ALL', text: 'Tất cả' }],
      }
    },
    watch: {
      'search.pageIndex': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async submitForm() {
        this.search.pageIndex = 1
        this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const response = await NotificationService.getListNotificationSystem({})
          if (response.code === 1000) {
            console.log(response.data)
            this.lists = response.data.list
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      create() {
        this.$router.push({ path: `/system-notification/create` })
      },
      edit(id) {
        this.$router.push({ path: `/system-notification/edit/${id}` })
      },
      detail(id) {
        this.$router.push({ path: `/system-notification/${id}` })
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }
  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }
  .UN_ACTIVE {
    color: #fff;
    background-color: #dc3545;
  }
  .category {
    width: 300px;
  }
</style>
